import 'appstart';
//import 'SCSSEntries/hotelRoundtrip.scss';
//import 'Vendors/knockout/knockout-pack';
import { GetBreakpointWidth } from 'Utils/globals-bp';
//import { isTouch, isApplePie, is_iPhone, IsPortraitMode, IsLandscapeMode, DetectIE } from 'Utils/device-utils';
//import { UpdateSiteHeaderSticky } from 'Modules/headroom.js';


//global.isTouch = /Android|webOS|iPhone|iPad|iPod|BlackBerry|windows phone|WindowsPhone/i.test(navigator.userAgent.toLowerCase());
//global.isApplePie = /iPhone|iPad|iPod/i.test(navigator.userAgent.toLowerCase());
//global.is_iPhone = /iPhone/i.test(navigator.userAgent.toLowerCase());

//import 'Utils/formatters';


//import 'SrcJS/knockout-extensions/knockout.spinner';

import 'Utils/mere.js';
//import 'Utils/slider.js'; //??? //2021-06-14 Disabled
//import 'Modules/map-container';
import 'Modules/hotelroundtrip-mapbox';
import 'Modules/hotel-page-nav';

//import(/* webpackChunkName: "searchbar-module" */ 'searchbar');
//import(/* webpackChunkName: "search-single-result-module" */ 'search-single-result');
//import(/* webpackChunkName: "sections-module" */ 'Modules/sections/frontpageHotelThemes.js');
import(/* webpackChunkName: "sections-module" */ 'Modules/sections/roundtripHotels.js');
import(/* webpackChunkName: "widgets-module" */ 'Widgets/widgetHotelThemesBoxes');




AppLoader.ready(function () {
    $('.hotel-description .readmoreHeight').readmore({
        selector: '.hotel-description .readmoreHeight',
        speed: 100,
        collapsedHeight: 48,
        heightMargin: 26,
        embedCSS: false,
        moreLink: '<a href="#" class="mere mere-button-sm-down mere-link-md-up mere-button-end">'+ AppData.Translations["hotelpage.read-more"] + '</a>',
        lessLink: '<a href="#" class="mere mere-button-sm-down mere-link-md-up mere-button-end expanded">' + AppData.Translations["hotelpage.show-less"] + '</a>'
    }).removeClass('readmore-placeholder');
});

AppLoader.ready(function () {
    let refresh_map = function () {
        AppLoader.raf(function () {
            if (map && typeof map.resize == "function") {
                map.resize();
            }
        });
    };


    //$('.panel-heading[data-target="#info-and-facts-panel-body"]').collapse();
    //$('#info-and-facts-panel-body').on('shown.bs.collapse', function () {
    //    if (map && typeof map.resize == "function") {
    //        map.resize();
    //    }
    //});
    // 2019-12-30 :BootStrap: event does not rise when 'bs-scripts.min.js' script's tag is defined early 
    //$('#info-and-facts-panel-body').on('show.bs.collapse', function () {
    //    refresh_map();
    //});
    $('.panel-heading[data-target="#info-and-facts-panel-body"]').on('click', function (e) {
        refresh_map();
    });

    $('.info-and-facts .attractions-text.readmoreHeight').readmore({
        selector: '.info-and-facts .attractions-text.readmoreHeight',
        speed: 100,
        collapsedHeight: 180,
        heightMargin: 24,
        embedCSS: false,
        moreLink: '<a href="#" class="mere mere-button">' + AppData.Translations["hotelpage.read-more"] + '</a>',
        lessLink: '<a href="#" class="mere mere-button expanded">' + AppData.Translations["hotelpage.show-less"] + '</a>',
        afterToggle: function (trigger, element, expanded) {
            //if (expanded) {
            if (GetBreakpointWidth() >= 1024) {
                refresh_map();
            }
            //}
        }
    }).removeClass('readmore-placeholder');
});












//**** show ******



AppLoader.ready(function () {

    var update_readmore_inside_panel = function (panel_heading) {
        let target = $(panel_heading).attr('data-target');
        if (target && target.length > 0) {
            let $target = $(target);
            if ($target && $target.length > 0) {
                setTimeout(function () {
                    let $readmore = $target.find('[data-readmore], .readmoreHeight');
                    $readmore.each(function () {
                        let $current = $(this);
                        //if ($current.css('max-height') == 'none') {
                        //    let maxHeight = $current.data('readmoreHeight--max-height') || '';
                        //    $current.css('max-height', maxHeight);
                        //}
                        $current.readmore('update');
                    });
                }, 300);
            }
        }
    };
    $(window).resize(function () {
        $('.panel-heading').each(function () {
            update_readmore_inside_panel(this);
        });
    });
    $('.panel-heading').on('click', function (e) {
        update_readmore_inside_panel(this);
    });
});




//AppLoader.setReady();